export const DEFAULT = 'rnnoise';
export const analyticsEvents = {
    JOIN: 'join the conference',
    TRACK_MUTE_CHANGED: 'track mute changed',
    DEVICE_LIST_CHANGED: 'device list changed',
    DEVICE_CHANGED_MANUALLY: 'device changed manually',
    TOGGLE_NOISE_SUPP: 'toggle noise suppression',
    NOISE_TYPE_CHANGED: 'noise suppression type changed'
};
